import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field, useField } from 'formik'
import { Wrapper } from 'components/common'
import { COLOR, FONT, GTR, BORDER } from 'styles/tokens'
import isArray from 'lodash/isArray'

import Icon from 'components/Icon'
import Error from 'components/form/Error'

const StyledLabel = styled.label`
  position: relative;
  display: flex;
  cursor: pointer;
  touch-action: manipulation;
  font-size: ${FONT.SIZE.M};
  font-weight: ${FONT.WEIGHT.REGULAR};
`

const StyledInput = styled(Field)`
  position: absolute;
  left: 0;
  top: 0;
  width: ${GTR.M};
  height: ${GTR.M};
  opacity: 0;
  cursor: pointer;
`

const StyledIcon = styled(Icon.Check)`
  display: none;
`

const StyledCheckbox = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${GTR.M};
  height: ${GTR.M};
  margin-right: ${GTR.S};
  border: 2px solid ${COLOR.GREY.DARK};
  border-radius: ${BORDER.RADIUS.S};
  color: ${COLOR.GREY.DARK};
  background-color: ${COLOR.WHITE};
  flex-shrink: 0;

  ${StyledInput}:focus + & {
    border-color: ${COLOR.GREY.DARK};
    box-shadow: 0 0 0 3px ${COLOR.STATE.HIGHLIGHT};
  }

  ${StyledInput}:checked + & {
    background-color: ${COLOR.ACCENT.PRIMARY};
    border-color: ${COLOR.ACCENT.PRIMARY};
  }

  ${StyledInput}:checked + & ${StyledIcon} {
    display: block;
  }
`

const StyledText = styled.span`
  transform: translateY(1px);
`

const Checkbox = ({ label, name, onChange, value, showError }) => {
  const [field] = useField(name)
  const checked = isArray(field.value)
    ? field.value.includes(value)
    : field.value === value

  return (
    <Wrapper>
      <StyledLabel>
        <StyledInput
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={(e) => {
            field.onChange(e)
            if (onChange) onChange()
          }}
        />
        <StyledCheckbox>
          <StyledIcon width={16} />
        </StyledCheckbox>
        <StyledText>
          {label}
          {showError && <Error name={name} />}
        </StyledText>
      </StyledLabel>
    </Wrapper>
  )
}

Checkbox.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showError: PropTypes.bool,
}

Checkbox.defaultProps = {
  label: '',
  onChange: null,
  value: true,
  showError: true,
}

export default Checkbox
